/**
 * Configuración del carrusel de imágenes/anuncios
 * 
 * Cada elemento debe tener:
 * - id: Identificador único
 * - image: Nombre del archivo de imagen en assets/images/ads/
 * - url: URL a la que se redirige al hacer clic (opcional)
 * - alt: Texto alternativo para accesibilidad
 */

// Importar imágenes
import ad1 from '../assets/images/ads/ad1.jpg';
import ad2 from '../assets/images/ads/ad2.jpg';
//import ad3 from '../assets/images/ads/ad3.jpg';
import ad4 from '../assets/images/ads/ad4.jpg';

export const carouselItems = [
    {
        id: 1,
        image: ad1,
        url: 'https://www.facebook.com/carlosgutrod',
        alt: 'Carlos Gutrod'
    },
    {
        id: 2,
        image: ad2,
        url: 'https://www.facebook.com/anzurgenilmotorsl',
        alt: 'Anzur Genil Motor'
    },
    {
        id: 4,
        image: ad4,
        url: 'https://www.facebook.com/OficinaFarmaciaVelasco',
        alt: 'Farmacia Velasco'
    },
];

// Configuración del carrusel
export const carouselSettings = {
    // Intervalo de cambio de imagen en milisegundos
    interval: 5000,
    // Duración de la transición en milisegundos
    transitionDuration: 500,
};
